<app-menu headerCSS="header-transparent"></app-menu>
<div class="header">
  <job-filter></job-filter>
</div>
<div class="header-inner bg-light">
  <div class="container">
    <div class="row">
      <div class="col-lg-6">
        <div class="candidates-user-info">
          <div class="jobber-user-info">
            <div class="profile-avatar">
              <img class="img-fluid " [src]="photoPath" alt="">
            </div>
            <div class="profile-avatar-info ml-4">
              <h3>{{fullName}}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-dashboard-candidate-menu></app-dashboard-candidate-menu>
<router-outlet></router-outlet>
<app-footer></app-footer>